/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import OpportunityForm from "../../components/OpportunityForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

function AvUploadingPage() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="avAccessibility" />
        <div className="doc-container" role="main" tabIndex={-1}>
          <section className="component-container center uploading">
            <img
              src="/status-image-vc.svg"
              alt="Illustration of file upload processing status"
              className="instruction-img"
            />
            <h1 className="display-title center" ref={mainRef} tabIndex={-1}>
              {"Processing Your Uploaded File"}
            </h1>
            <p>
              We will send you a notification with the link to download
              converted file when the results are ready
            </p>
            <button
              className="center upload-button"
              onClick={() => navigate("/avaccess")}
              aria-label="Go back to Audio/Video Accessibility page"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/avaccess');
                }
              }}
            >
              Ok, Got it
            </button>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AvUploadingPage;
